module.exports = "/_next/static/images/db95fbe2a5b3bc28a4769344ee19c81f-product-information-md-1x.jpg.webp";